import type { UserInfo } from './UserInfo';

export enum MediumType {
  Push = 800,
  Email = 820,
  Telegram = 830,
  Discord = 840
}

export type MediumDisplay = 'Email' | 'Push' | 'Discord' | 'Telegram';

export type Product = {
  name: string;
  lookup_key: string;
  mediums: ProductMedium[];
  parents: string[];
  discord_channel_ids: string[];
  num_subs: number;
};

export type ProductMedium = {
  type: MediumType;
  display: MediumDisplay;
  num_subs: number;
};

export type DiscordNotificationRole = {
  id: number;
  name: string;
};

export type PublishQueryResponse = {
  products: Product[];
  discord_notification_roles: DiscordNotificationRole[];
  userInfo: UserInfo;
};

export interface PlayData {
  capperKey: string;
  sms_title: string;
  message: string; // play content, the TextPick model calls it "message"
  product_keys: string[];
  discord_role_ids: string[];
}

export interface PublishPlaySuccess {
  message: string;
  url: string;
}
